   <template>

<div class="row">
    <div class="col-md-8">
        <!-- <br> -->
        <div class="table-responsive p-0">
            <table class="table table-bordered">
                <tr>
                    <th>{{$t('form.employee.file')}}</th>
                    <th>{{$t('form.student.UploadTimestamp')}}</th>
                    <th>{{$t('form.employee.fileName')}}</th>
                    <th>{{$t('form.employee.fileDescription')}}</th>
                    <th class="text-right" v-if="!readonly">
                        {{$t('form.employee.action')}}</th>
                </tr>
                <tbody>
                    <tr v-for="(file , index) in contracts" v-bind:key="index">
                        <td>
                            <i class="fa fa-file" aria-hidden="true"></i>
                        </td>
                        <td class="text-center">
                        {{file.UploadTimestamp}}
                        </td>
                        <td>
                            <a href="#"
                                @click.prevent="downloadContract(file , true)" class="mr-2">{{getAttachmentFileName(file.Name)}}</a>

                            | <a href="#" @click.prevent="downloadContract(file)" class="ml-2"> {{$t('button.view')}}</a>

                        </td>
                        <td>
                            <input type="text" class="form-control"
                                v-model="contracts[index].Description">
                        </td>
                        <td class="text-right" v-if="!readonly">
                            <span style="color:red;cursor:pointer"
                                @click="removeContract(index,file)">
                                <i class="fa fa-times"></i>
                            </span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

    <div class="col-md-4" v-if="!readonly">
        <div class="form-group">
            <label class="control-label"
                for="StatusID:">{{$t('form.employee.fileAttach')}}</label>

            <vue-dropzone ref="myVueDropzone" id="dropzone2" :options="contractDropzone"
                @vdropzone-success="contractUploaded"
                @vdropzone-error="uploadFileError"
                @vdropzone-processing="isLoading=true">
            </vue-dropzone>
        </div>
    </div>
</div>
</template>

<script>

import vue2Dropzone from "vue2-dropzone";

export default {
name:'Contracts',
 props: { readonly:Boolean, removeContract:Function, downloadContract:Function, contractDropzone:Object, contractUploaded:Function, contracts:Array, getAttachmentFileName:Function, uploadFileError:Function },

components: {
      vueDropzone: vue2Dropzone,
    },
}
</script>
